import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 403 Unauthorized Page Component
 */
const UnauthorizedPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">403</h1>
        <h2 className="text-3xl font-semibold text-gray-900 mt-4 mb-2">Access denied</h2>
        <p className="text-lg text-gray-600 mb-8">You do not have permission to view this page.</p>
        <Link to="/dashboard" className="btn btn-primary">
          Go back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
